// ---------------------------------------------------------------------------
// Results event registry
//
// One source of truth for every event name used by the Nosto search &
// merchandising results pipeline. Reference these constants instead of
// string literals so typos crash at load time, not silently at runtime.
//
// Naming convention:
//   listings:<layer>:<subject>:<verb>
//     layer   = ui | api | state
//     subject = facet, facets, products, sort, pagination, ...
//     verb    = added, removed, changed, fetched, updated, ...
// ---------------------------------------------------------------------------

window.theme = window.theme || {}
window.theme.results = window.theme.results || {}

window.theme.results.events = {
  // UI intents — published by components, consumed by the state layer
  UI: {
    FACET_ADDED: 'listings:ui:facets:added',
    FACET_REMOVED: 'listings:ui:facet:removed',
    FACET_CLEAR_ALL: 'listings:ui:facet:clearAll',
    SORT_CHANGED: 'listings:ui:sort:changed',
    PRICE_CHANGED: 'listings:ui:price:changed',
    PAGINATION_CHANGED: 'listings:ui:pagination:changed',
    PAGINATION_NEXT: 'listings:ui:pagination:next',
  },

  // API layer — fetch requests in, results out
  API: {
    FETCH_PRODUCTS: 'listings:api:fetch:products',
    PRODUCTS_FETCHED: 'listings:api:products:fetched',
    FACETS_FETCHED: 'listings:api:facets:fetched',
    SHOPIFY_FALLBACK: 'listings:shopify:products:fetched',
  },

  // State layer broadcasts — consumed by components
  STATE: {
    PRODUCTS_UPDATED: 'listings:state:products:updated',
    FACETS_UPDATED: 'listings:state:facets:updated',
    ACTIVE_FACETS_UPDATED: 'listings:state:activeFacets:updated',
    ACTIVE_SORT_UPDATED: 'listings:state:activeSort:updated',
    PAGINATION_UPDATED: 'listings:state:pagination:updated',
    SORT_READY: 'listings:state:sort:ready',
  },
  TRACKING: {
    PRODUCT_CLICKED: 'listings:tracking:product:clicked',
    PRODUCT_ADDED_TO_CART: 'listings:tracking:product:added-to-cart',
    SUBMIT_SEARCH: 'listings:tracking:submit-search',
  },
}
